<template>
  <el-dialog
    :visible.sync="show"
    :title="title"
    width="800px"
    :close-on-click-modal="false"
  >
    <!-- 用户类型 -->
    <el-row :span="24" type="flex" align="middle">
      <el-col
        :span="4"
        :offset="2"
        class="d-flex right required"
      >
        用户类型：
      </el-col>
      <el-col
        :span="16"
      >
        <el-select class="select-class"
          :disabled="isView" 
          v-model="detail.user_type" 
          :placeholder="`请选择`"
          @change="userTypeChange">
          <el-option
            v-for="item in userTypes"
            :key="item.value"
            :label="item.name"
            :value="item.value">
          </el-option>
        </el-select>
      </el-col>
    </el-row>

    <!-- 经销商分配 -->
    <el-row v-if="(user.role_id == 1 || user.role_id == 6) && detail.user_type === 1" :span="24" type="flex" align="middle" class="mt20">
      <el-col
        :span="4"
        :offset="2"
        class="d-flex right required"
      >
        经销商分配：
      </el-col>
      <el-col
        :span="16"
      >
        <el-cascader class="select-class" :disabled="isView || dealerDisabled" :props="cascaderProps" :options="dealerOptions" v-model="detail.dealer_id_arr" clearable></el-cascader>
      </el-col>
    </el-row>

    <!-- 租户分配 -->
    <el-row v-if="(user.role_id == 1 || user.role_id == 5 || user.role_id === 6) && detail.user_type === 0" :span="24" type="flex" align="middle" class="mt20">
      <el-col
        :span="4"
        :offset="2"
        class="d-flex right required"
      >
        租户分配：
      </el-col>
      <el-col
        :span="16"
      >   
        <tenantSelection @clickTenant="getTenantInfo" :data="tenantData"></tenantSelection>
      </el-col>
    </el-row>

    <el-row :span="24" type="flex" align="middle" class="mt20">
      <el-col
        :span="4"
        :offset="2"
        class="d-flex right required"
      >
        用户账号：
      </el-col>
      <el-col
        :span="16"
      >
        <el-input
          :disabled="isView"
          v-model="detail.username"
          :placeholder="`请输入`"
          clearable
        ></el-input>
      </el-col>
    </el-row>

    <el-row :span="24" type="flex" align="middle" class="mt20">
      <el-col
        :span="4"
        :offset="2"
        class="d-flex right required"
      >
        登录密码：
      </el-col>
      <el-col
        :span="16"
      >
        <el-input
          :disabled="isView || mode === 'edit'"
          type="password"
          v-model="detail.password"
          :placeholder="`请输入`"
          clearable
        ></el-input>
      </el-col>
    </el-row>

    <el-row :span="24" type="flex" align="middle" class="mt20">
      <el-col
        :span="4"
        :offset="2"
        class="d-flex right required"
      >
        确认密码：
      </el-col>
      <el-col
        :span="16"
      >
        <el-input
          :disabled="isView || mode === 'edit'"
          type="password"
          v-model="detail.confirm_password"
          :placeholder="`请输入`"
          clearable
        ></el-input>
      </el-col>
    </el-row>

    <el-row :span="24" type="flex" align="middle" class="mt20">
      <el-col
        :span="4"
        :offset="2"
        class="d-flex right required"
      >
        用户姓名：
      </el-col>
      <el-col
        :span="16"
      >
        <el-input
          :disabled="isView"
          v-model="detail.name"
          :placeholder="`请输入`"
          clearable
        ></el-input>
      </el-col>
    </el-row>

    <!-- 工号 -->
    <el-row :span="24" type="flex" align="middle" class="mt20">
      <el-col
        :span="4"
        :offset="2"
        class="d-flex right"
      >
        工号：
      </el-col>
      <el-col
        :span="16"
      >
        <el-input
          :disabled="isView"
          v-model="detail.empcode"
          :placeholder="`请输入`"
          clearable
        ></el-input>
      </el-col>
    </el-row>

    <!-- 职务 -->
    <el-row :span="24" type="flex" align="middle" class="mt20">
      <el-col
        :span="4"
        :offset="2"
        class="d-flex right"
      >职务：</el-col>
      <el-col
        :span="16"
      >
        <el-select class="select-class" :disabled="isView" clearable v-model="detail.job_category" :placeholder="`请选择`">
          <el-option
            v-for="item in postList"
            :key="item.id"
            :label="item.name"
            :value="item.value">
          </el-option>
        </el-select>
      </el-col>
    </el-row>

    <!-- 手机号 -->
    <el-row :span="24" type="flex" align="middle" class="mt20">
      <el-col
        :span="4"
        :offset="2"
        class="d-flex right"
        :class="{ 'required': detail.is_sms === 1 }"
      >
        手机：
      </el-col>
      <el-col
        :span="16"
      >
        <el-input
          :disabled="isView"
          v-model="detail.mobile"
          :placeholder="`请输入`"
          clearable
        ></el-input>
      </el-col>
    </el-row>

    <!-- 电子邮件地址 -->
    <el-row :span="24" type="flex" align="middle" class="mt20">
      <el-col
        :span="4"
        :offset="2"
        class="d-flex right"
      >
        电子邮件地址：
      </el-col>
      <el-col
        :span="16"
      >
        <el-input
          :disabled="isView"
          v-model="detail.email"
          :placeholder="`请输入`"
          clearable
        ></el-input>
      </el-col>
    </el-row>
    
    <!-- 科室分配 -->
    <el-row v-if="detail.user_type === 0" :span="24" type="flex" align="middle" class="mt20">
      <el-col
        :span="4"
        :offset="2"
        class="d-flex right"
        :class="{ 'required': detail.user_type === 0 }"
      >
        科室分配：
      </el-col>
      <el-col
        :span="16"
      >
        <el-select
          :disabled="isView"
          class="select-class"
          v-model="detail.department_id"
          remote
          filterable
          :remote-method="getDepartmentOpts"
          @focus="getDepartmentOpts()"
        >
          <el-option
            v-for="item in dempartmentOptions"
            :key="item.id"
            :label="item.name"
            :value="item.id">
          </el-option>
        </el-select>
      </el-col>
    </el-row>

    <el-row :span="24" type="flex" align="middle" class="mt20">
      <el-col
        :span="4"
        :offset="2"
        class="d-flex right"
      >
        状态：
      </el-col>
      <el-col
        :span="16"
      >
        <el-radio-group
          :disabled="isView"
          v-model="detail.status">
          <el-radio :label="1">正常</el-radio>
          <el-radio :label="2">冻结</el-radio>
        </el-radio-group>
      </el-col>
    </el-row>

    <!-- 身份 -->
    <el-row :span="24" type="flex" align="middle" class="mt20">
      <el-col
        :span="4"
        :offset="2"
        class="d-flex right required"
      >
        身份：
      </el-col>
      <el-col
        :span="16"
      >
        <el-radio-group
          :disabled="isView || (mode === 'edit' && user.role_id !== 1)"
          v-model="detail.role_id">
          <el-radio
            v-if="detail.user_type === 1"
            :label="6"
          >管理用户</el-radio>
          <el-radio
            v-else
            :disabled="((user.role_id == 5 && detail.tenant_id == 1) || ( user.role_id == 2) ) && mode === 'new'"
            :label="2"
          >管理用户</el-radio>
          <el-radio
            v-if="detail.user_type === 0"
            :label="3"
          >普通用户</el-radio>
          <el-radio
            v-if="detail.tenant_id === 1 && detail.user_type === 0"
            :label="4"
          >仓库用户</el-radio>
        </el-radio-group>
      </el-col>
    </el-row>

    <!-- 短信通知 -->
    <el-row :span="24" type="flex" align="middle" class="mt20" v-if="user.is_super_tenant_admin && mode == 'new'">
      <el-col
        :span="4"
        :offset="2"
        class="d-flex right"
      >短信通知：</el-col>
      <el-col
        :span="16"
      >
        <el-radio-group
          :disabled="isView"
          v-model="detail.is_sms">
          <el-radio :label="1">是</el-radio>
          <el-radio :label="0">否</el-radio>
        </el-radio-group>
      </el-col>
    </el-row>

    <div
      slot="footer"
      class="d-flex right"
    >
      <el-button
        size="small"
        @click="close"
      >关闭</el-button>
      <el-button
        v-show="!isView"
        size="small"
        type="primary"
        @click="save"
      >确定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import tenantSelection from '@/components/common/tenantSelection'
import {
  mapGetters
} from 'vuex';
import {
  userManage,
  getTenantOpts,
  getTenantDepartment,
  userDetail,
  dealerSelect
} from '@/api.js';
export default {
  name: 'TenantManagementEdit',
  components: {
    tenantSelection
  },
  data() {
    return {
      userTypes: [
        {
          name: `经销商用户`,
          value: 1
        },
        {
          name: `租户用户`,
          value: 0
        }
      ],
      cascaderProps:{
        label:'name',
        children:'children',
        value:'id',
        checkStrictly: true
      },
      dealerOptions: [],
      tenantData:{
        inputData:'',
        clearable:false,
        disabled:false
      },
      postList:[],
      show: false,
      isView: false,
      detail: {
        id: undefined,
        status: 1,
        role_id: 3,
        is_sms: 0,
        dealer_id_arr: []
      },
      addressData: [],
      tenantOpts: [],
      dempartmentOptions: [],
      dealerDisabled: false
    }
  },
  computed: {
    ...mapGetters(['user','addressOptions']),
    mode() {
      // 新建或编辑
      const {
        id
      } = this.detail
      let mode = 'new'; // new or edit
      if (id && Number(id)) {
        mode = 'edit'
      } else {
        mode = 'new'
      }

      return mode
    },
    title() {
      let title = ''
      if (this.mode === 'new') {
        title = `新增`
      } else if (this.mode === 'edit') {
        title = `编辑`
      }

      if (this.isView) {
        title = `详情`
      }

      return title
    },
    address(){
      // 区县下一级列表初始化
      let arr = this.$utils.deepCopy(this.addressOptions)
            // 避免重复做处理
      for (const item of arr) {
        item.code = item.code + 'code'
      }
      for (const province of arr) {
        for (const city of province.children) {
          for (const county of city.children) {
            this.$set(county,'children',[])
          }
        }
      }
      this.tenantOpts.forEach(item => {
        const province = arr.find(i => i.code === item.province + 'code')
        if (province) {
          const city = province.children.find(i => i.code === item.city)
          if (city) {
            const county = city.children.find(i => i.code === item.area)
            if (county) {
              county.children.push({
                name: item.name,
                code: item.id
              })
            }
          }
        }
      })
      return arr
    }
  },
  created(){
    this.getDicts()
  },
  methods: {
    getTenantInfo(data){
      this.detail.tenant_id = data.id
      this.tenantData.inputData = data.name
      this.tenantData.user_type = this.detail.user_type
      this.$set(this.detail,'department_id',undefined) // 当重新选择租户的时候要清空科室数据
    },
    getDealerSelect(name = undefined){
      return this.$request('get', dealerSelect, { country: this.user.country, name })
      .then((res) => {
        this.dealerOptions = res
      })
    },
    userTypeChange(type) {
      this.$set(this.detail, 'tenant_id', undefined)
      this.$set(this.detail, 'dealer_id', undefined)
      this.tenantData.inputData = ''
      this.tenantData.user_type = this.detail.user_type
      
      if (type === 1) {
        const { dealer_id } = this.user
        this.$set(this.detail, 'role_id', 6)
        if (this.user.role_id !== 1) {
          this.$set(this.detail, 'dealer_id', dealer_id)
          let haveChildren = false
          for (let i = 0; i < this.dealerOptions.length; i++) {
            const dealer = this.dealerOptions[i];
            if (dealer.children) {
              for (let j = 0; j < dealer.children.length; j++) {
                if (dealer.children[j].id === this.detail.dealer_id) {
                  haveChildren = true
                  this.$set(this.detail, 'dealer_id_arr', [dealer.id, this.detail.dealer_id])
                }
              }
            }
          }
          if(!haveChildren){
            this.$set(this.detail, 'dealer_id_arr', [this.detail.dealer_id])
          }
          this.dealerDisabled = true
        }
      } else if (type === 0) {
        this.$set(this.detail, 'role_id', 2)
      } else {
        this.$set(this.detail, 'role_id', undefined)
      }
    },
    getDicts() {
      this.$utils.getDict([607]).then(res => {
        if (res) {
          this.postList = res[607]
        }
      })
    },
    async open(config = {}) {
      this.reset()
      const {
        id,
        isView,
        tenant_text
      } = config
      this.isView = !!isView
      this.tenantData.disabled = !this.user.is_super_tenant_admin || this.isView || this.mode === 'edit'
      this.tenantData.inputData = tenant_text
      this.tenantData.user_type = this.detail.user_type

      await this.getDealerSelect()
      await this.getTenantsOpts()
      if (id && Number(id)) {
        // 编辑时
        const detail = await this.getUserDetail(id)
        if (!detail.job_category){ // 后端返回0时需要将0清除
          detail.job_category = undefined
        }
        this.detail = detail || {}
        if(detail && detail.dealer_id){ // 找到经销商的父元素
          let haveChildren = false
          for (let i = 0; i < this.dealerOptions.length; i++) {
            const dealer = this.dealerOptions[i];
            if (dealer.children) {
              for (let j = 0; j < dealer.children.length; j++) {
                if (dealer.children[j].id === detail.dealer_id) {
                  haveChildren = true
                  this.$set(this.detail, 'dealer_id_arr', [dealer.id, detail.dealer_id])
                }
              }
            }
          }
          if(!haveChildren){
            this.$set(this.detail, 'dealer_id_arr', [detail.dealer_id])
          }
          console.log(this.detail.dealer_id_arr,'this.detail.dealer_id_arr')  ;
          
        }
        this.getDepartmentOpts()
      } else {
        // 新建时
        this.defaultTenant()

        if (this.detail.tenant_id) {
          this.defaultDeparment()
        }
      }

      this.fakePassword()      
      this.show = true
    },
    fakePassword() {
      // 基于原型上密码显示的需要，接口不会返回或接收
      if (this.isView || (this.detail.id && Number(this.detail.id))) {
        this.detail.password = this.detail.password || '123456'
        this.detail.confirm_password = this.detail.confirm_password || '123456'
      }
    },
    defaultTenant() {
      // 默认租户逻辑
      const {
        tenant_id,
        role_id
      } = this.user

      if (role_id === 2) {
        this.detail.tenant_id = tenant_id
      }
    },
    async defaultDeparment() {
      // 默认科室逻辑
      await this.getDepartmentOpts()

      let department_id = undefined
      this.dempartmentOptions.forEach(i => {
        if (i.type === 1) {
          department_id = i.id
        }
      })
      
      this.$set(this.detail, 'department_id', department_id)
      if(this.detail.tenant_id != 1 && this.detail.role_id == 4){ // 当不是选择“超级管理租户”，时需要判断“仓库用户”是否被选中，如果选中需要重置，因为仓库管理员只能是被“超级管理租户”，选择。
        this.$set(this.detail, 'role_id', undefined)
      }
      if(this.user.role_id == 5 && this.detail.tenant_id == 1 && this.detail.role_id == 2){ // 当登录的是超级管理租户下的管理用户，并且“租户分配”选择了超级管理租户时，如果“身份”选中了管理用户，那么需要清空”身份“的值，因为超级管理租户下的管理用户不能新建”管理用户“
        this.$set(this.detail, 'role_id', undefined)
      }
    },
    getUserDetail(id) {
      // 获取用户详情
      const url = userDetail.replace('{id}', id)

      return this.$request('get', url)
    },
    getTenantsOpts(name = null , area = null , province = null , city = null) {
      return this.$request('get', getTenantOpts, { name,province,city,area,user_type:this.detail.user_type })
      .then(res => {
        this.tenantOpts = res || []
      })
    },
    getDepartmentOpts(name = undefined) {
      const {
        tenant_id
      } = this.detail
      if(!tenant_id){
        this.$message.error(`请先选择租户`)
        return
      }
      const query = {
        tenant_id,
        name
      }

      return this.$request('get', getTenantDepartment, query)
      .then((res) => {
        this.dempartmentOptions = res || []
      })
    },
    reset() {
      this.detail = {
        id: undefined,
        status: 1,
        role_id: 3,
        is_sms: 0
      },
      this.isView = false
    },
    validateFields(params) {
      // 校验字段
      const {
        username,
        name,
        department_id,
        tenant_id,
        password,
        confirm_password,
        mobile,
        user_type,
        is_sms,
        dealer_id,
        role_id,
        email
      } = params
      
      let msg = '';
      const roleIdArr = [1,2,6]
      if (user_type === undefined) {
        msg = `用户类型不能为空`
      } else if (user_type === 1 && !dealer_id){
        msg = `经销商不能为空`
      } else if (user_type === 0 && !tenant_id && roleIdArr.includes(this.user.role_id)) {
        msg = `租户不能为空`
      } else if (!username || !username.trim()) {
        msg = `账号不能为空`
      } else if (!password && this.mode === 'new') {
        msg = `密码不能为空`
      } else if (!confirm_password && this.mode === 'new') {
        msg = `确认密码不能为空`
      } else if (!name || !name.trim()) {
        msg = `姓名不能为空`
      } else if (is_sms && !mobile) {
        msg = `手机号不能为空`
      } else if (user_type === 0 &&  !department_id) {
        msg = `科室不能为空`
      } else if (email && !this.$utils.isEmail(email)) {
        msg = `请填写正确的电子邮件地址`
      } else if (!role_id) {
        msg = `身份不能为空`
      }

      if (msg) {
        this.$message.error(msg)
      }

      return !msg
    },
    save() {
      // 保存
      const {
        id,
        mobile,
        username,
        name,
        department_id,
        tenant_id,
        status,
        password,
        confirm_password,
        role_id,
        empcode,
        job_category,
        is_sms,
        user_type,
        dealer_id_arr,
        email
      } = this.detail
      if(dealer_id_arr && dealer_id_arr.length != 0){
        var dealer_id = dealer_id_arr[dealer_id_arr.length - 1]
      }
      const params = {
        id,
        mobile,
        username,
        name,
        department_id,
        tenant_id: this.user.ins_tenant_id <=0 ? this.user.tenant_id : tenant_id,
        status,
        password: this.mode === 'new' ? password : undefined,
        confirm_password: this.mode === 'new' ? confirm_password : undefined,
        role_id,
        empcode,
        job_category: job_category ? job_category : 0,
        is_sms,
        user_type,
        dealer_id,
        email
      }
      const validate = this.validateFields(params)
      if (!validate) return

      this.$request('post', userManage, params)
      .then(res => {
        if (res) {
          this.$message.success(`操作成功`)
          this.notifyRefresh()
          this.close()
        }
      })
    },
    notifyRefresh() {
      this.$emit('fresh')
    },
    close() {
      this.show = false
    },
    async remoteSearch(value){
      let res = await this.$request('get', getTenantOpts, { name:value })
      this.tenantOpts = res || []
    },
    expandChange(node){
      if (node[2]) {
        this.getTenantsOpts(null,node[2])
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .photo-btn {
    width: 60px;
    height: 60px;
    line-height: 60px;
    text-align: center;
    background-color: lightgray;
    border-radius: 4px;
    cursor: pointer;
    i {
      color: #fff;
      font-size: 30px;
      vertical-align: middle;
    }
  }
  .logo-image {
    height: 60px;
    width: auto;
  }
  .select-class{
    width: 100%;
  }
</style>
<style lang="scss">
  .cascader-style {
    height: 30vh;
    .el-cascader-panel {
      height: 100%;
    }
  }
</style>